export default __webpack_public_path__ + "no_preview.png";